/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum GlobalFilterEvents {
    Change = 'GlobalFilterChange',
}
